import { useContext } from 'react';
import { WalletConnectionContext } from '@/contexts/WalletConnectionContext';

/**
 * Hook para acessar contexto de conexão com carteiras
 * Suporta: Metamask (EVM), Phantom (Solana)
 * 
 * @returns {Object} Contexto de conexão com wallets
 * 
 * @example
 * const { connectedWallet, walletAddress, connectMetamask, disconnectWallet } = useWalletConnection();
 */
export function useWalletConnection() {
  const context = useContext(WalletConnectionContext);

  if (!context) {
    throw new Error('useWalletConnection deve ser usado dentro de WalletConnectionProvider');
  }

  return context;
}
